// extracted by mini-css-extract-plugin
module.exports = {"Loading":"Loading_Loading__QcyHn","spin":"Loading_spin__bRHku"};